import React from 'react';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';

import { useNotification } from '../context/notification';

function Notification() {
  const { notifications, removeNotification } = useNotification();

  return (
    <Stack spacing={2} sx={{ zIndex: 1300 }} className="w-fit m-auto absolute right-1/2 translate-x-1/2 top-10 z-50">
      {notifications.map((alert, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fade in mountOnEnter unmountOnExit key={`alert_${index}`}>
          <Paper elevation={6}>
            <Alert severity={alert.severity} onClose={() => removeNotification(index)}>
              <span className="font-medium">{alert.message}</span>
            </Alert>
          </Paper>
        </Fade>
      ))}
    </Stack>
  );
}

Notification.propTypes = {};

export default Notification;
